import getters from './getters';
import mutations from './mutations';
var state = function state() {
  return {
    notification: {}
  };
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters
};